exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reservationRestTimeWrapper[data-v-52f2a084]{position:fixed;z-index:9999;left:0;top:0;width:100%;text-align:center;padding:10px;background:#ecc331}", ""]);

// exports
